export default ({ to, from, next }) => {
    if (localStorage.getItem('userToken')) {
        next('/intercom')
        
        return false;
    }

    next()
}